// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logistik-dienstplaene-page {
  padding: 0 0 4rem;
  text-align: left;
}

.logistik-dienstplaene-page h1 {
  color: var(--mittelblau);
}

.logistik-hub-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
  gap: 0.8rem;
  margin: 0.75rem 0 1.2rem;
}

.logistik-hub-card {
  min-height: 7.5rem;
  border-radius: 8px;
  background: var(--mittelblau);
  color: var(--weiss);
  display: grid;
  align-content: center;
  justify-items: start;
  gap: 0.55rem;
  padding: 1.1rem;
  box-shadow: 0 2px 8px rgba(0, 80, 158, 0.18);
}

.logistik-hub-card.secondary {
  background: var(--weiss);
  border: 2px solid var(--mittelblau);
  color: var(--mittelblau);
}

.logistik-hub-card .material-symbols-outlined {
  color: var(--weiss);
  font-size: 2.2rem;
}

.logistik-hub-card.secondary .material-symbols-outlined,
.logistik-hub-card.secondary span:last-child {
  color: var(--mittelblau);
}

.logistik-hub-card span:last-child {
  color: var(--weiss);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.55rem;
  line-height: 1;
}

.logistik-view-tabs,
.logistik-day-chips,
.logistik-person-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin: 0.75rem 0 1rem;
}

.logistik-view-tab,
.logistik-day-chip,
.logistik-person-chip {
  width: auto;
  min-height: auto;
  margin: 0;
  border: 2px solid var(--mittelblau);
  border-radius: 999px;
  background: var(--weiss);
  color: var(--mittelblau);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.55rem 0.8rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.92rem;
  line-height: 1;
  text-align: center;
}

.logistik-view-tab.active,
.logistik-day-chip.active,
.logistik-person-chip:active {
  background: var(--mittelblau);
  color: var(--weiss);
}

.logistik-view-tab .material-symbols-outlined {
  color: inherit;
  font-size: 1.15rem;
}

.logistik-day-chip {
  border-color: rgba(0, 80, 158, 0.38);
  padding: 0.48rem 0.65rem;
}

.logistik-person-chips {
  max-height: 14rem;
  overflow: auto;
  padding-bottom: 0.2rem;
}

.logistik-person-chips.compact {
  max-height: none;
}

.logistik-search-panel {
  margin: 0.75rem 0 1rem;
}

.logistik-search-panel label {
  color: var(--mittelblau);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.15rem;
  margin-bottom: 0.3rem;
}

.logistik-dienstplaene-page input.logistik-search-input {
  width: 100%;
  border: none;
  border-radius: 8px;
  background: rgba(180, 200, 130, 0.55);
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  padding: 0.85rem 0.95rem;
  margin-bottom: 0;
}

.logistik-dienstplaene-page input.logistik-search-input::placeholder {
  color: var(--placeholder);
}

.logistik-result-section,
.logistik-subsection {
  margin-top: 1.2rem;
}

.logistik-result-section h2,
.logistik-subsection h3 {
  color: var(--mittelblau);
  text-align: left;
}

.logistik-subsection h3 {
  font-size: 1.25rem;
}

.logistik-list {
  display: grid;
  gap: 0.55rem;
}

.logistik-duty-row,
.logistik-ride-row,
.logistik-ride-card {
  border-radius: 8px;
  background: var(--weiss);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
}

.logistik-duty-row,
.logistik-ride-row {
  display: grid;
  grid-template-columns: 5.6rem minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;
  padding: 0.85rem 0.95rem;
}

.logistik-duty-time,
.logistik-ride-time,
.logistik-ride-date {
  color: var(--mittelblau);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.1rem;
  line-height: 1;
}

.logistik-duty-time {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.logistik-ride-time {
  display: grid;
  gap: 0.16rem;
}

.logistik-ride-time span,
.logistik-ride-time small {
  color: var(--mittelblau);
}

.logistik-ride-time small {
  font-family: 'Circular', sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.15;
}

.logistik-repeat {
  color: var(--mittelblau);
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  line-height: 1;
}

.logistik-duty-title,
.logistik-ride-title {
  color: var(--dunkelgruen);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.25rem;
  line-height: 1;
}

.logistik-duty-desc,
.logistik-ride-meta,
.logistik-ride-info,
.logistik-person-list {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.9rem;
  line-height: 1.35;
  margin-top: 0.18rem;
}

.logistik-person-list {
  color: var(--dunkelgruen);
  font-weight: 700;
}

.logistik-ride-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.logistik-ride-meta span {
  display: inline-flex;
  border-radius: 999px;
  background: var(--blassgruen);
  color: var(--mittelblau);
  padding: 0.12rem 0.45rem;
}

.logistik-ride-card {
  overflow: hidden;
}

.logistik-ride-card .logistik-ride-date {
  background: var(--mittelblau);
  color: var(--weiss);
  padding: 0.45rem 0.95rem;
}

.logistik-ride-card .logistik-ride-row {
  box-shadow: none;
  border-radius: 0;
}

.logistik-day-details {
  border-radius: 8px;
  background: var(--weiss);
  margin-bottom: 0.65rem;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.logistik-day-details summary {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 0.95rem;
  color: var(--mittelblau);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.25rem;
  list-style: none;
}

.logistik-day-details summary::-webkit-details-marker {
  display: none;
}

.logistik-day-details summary small {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.78rem;
}

.logistik-day-details .logistik-day-content {
  padding: 0 0.75rem 0.85rem;
}

.logistik-inline-link {
  display: inline-block;
  margin-top: 0.65rem;
  color: var(--mittelblau);
  font-family: 'Circular', sans-serif;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.logistik-empty,
.logistik-web-state {
  border-radius: 8px;
  background: var(--weiss);
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  padding: 1rem;
  text-align: center;
}

.logistik-web-state.error {
  color: var(--blutorange);
}

.logistik-service-note,
.logistik-matrix-access {
  border-radius: 8px;
  background: var(--weiss);
  color: var(--dunkelgruen);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
}

.logistik-service-note {
  padding: 0.85rem 0.95rem;
  margin: 0 0 1rem;
}

.logistik-service-note span,
.logistik-matrix-access summary {
  display: block;
  color: var(--mittelblau);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.15rem;
}

.logistik-service-note p {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.9rem;
  line-height: 1.35;
  margin-top: 0.2rem;
}

.logistik-matrix-access {
  padding: 0.7rem 0.85rem;
  margin-top: 0.9rem;
}

.logistik-matrix-access summary {
  cursor: pointer;
  list-style: none;
}

.logistik-matrix-access summary::-webkit-details-marker {
  display: none;
}

.logistik-matrix-access a {
  display: inline-block;
  margin-top: 0.65rem;
  border: 2px solid var(--mittelblau);
  border-radius: 999px;
  color: var(--mittelblau);
  font-family: 'Circular', sans-serif;
  font-size: 0.9rem;
  padding: 0.48rem 0.75rem;
  text-align: center;
}

.logistik-matrix-wrapper {
  width: 100%;
  overflow: auto;
  border-radius: 8px;
  background: var(--hellgruen);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
}

.logistik-matrix-table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: var(--hellgruen);
}

.logistik-matrix-table th,
.logistik-matrix-table td {
  min-width: 9rem;
  border: none;
  border-left: 1px solid rgba(100, 130, 2, 0.18);
  border-top: 1px solid rgba(100, 130, 2, 0.18);
  padding: 0.55rem;
  vertical-align: top;
  text-align: left;
}

.logistik-matrix-table thead th,
.logistik-matrix-table tbody th {
  background: var(--mittelblau);
  color: var(--weiss);
  font-family: 'Staatliches', sans-serif;
}

.logistik-matrix-table tbody th {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 4.8rem;
}

.logistik-matrix-table td {
  background: var(--blassgruen);
  color: var(--dunkelgruen);
}

.logistik-matrix-table td.filled {
  background: var(--weiss);
}

.logistik-matrix-entry {
  display: grid;
  gap: 0.12rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.85rem;
  line-height: 1.25;
}

.logistik-matrix-entry strong {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-weight: 700;
}

.logistik-matrix-entry span {
  color: var(--mittelblau);
  font-family: 'Circular', sans-serif;
}

@media (max-width: 650px) {
  .logistik-hub-grid {
    grid-template-columns: 1fr;
  }

  .logistik-view-tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .logistik-view-tab {
    width: 100%;
  }

  .logistik-duty-row,
  .logistik-ride-row {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }

  .logistik-matrix-access a {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dienstplaene/logistik/LogistikDienstplaene.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mCAAmC;EACnC,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;;EAGE,wBAAwB;EACxB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,mCAAmC;EACnC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;EACpB,wBAAwB;EACxB,mCAAmC;EACnC,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,6CAA6C;EAC7C,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".logistik-dienstplaene-page {\n  padding: 0 0 4rem;\n  text-align: left;\n}\n\n.logistik-dienstplaene-page h1 {\n  color: var(--mittelblau);\n}\n\n.logistik-hub-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));\n  gap: 0.8rem;\n  margin: 0.75rem 0 1.2rem;\n}\n\n.logistik-hub-card {\n  min-height: 7.5rem;\n  border-radius: 8px;\n  background: var(--mittelblau);\n  color: var(--weiss);\n  display: grid;\n  align-content: center;\n  justify-items: start;\n  gap: 0.55rem;\n  padding: 1.1rem;\n  box-shadow: 0 2px 8px rgba(0, 80, 158, 0.18);\n}\n\n.logistik-hub-card.secondary {\n  background: var(--weiss);\n  border: 2px solid var(--mittelblau);\n  color: var(--mittelblau);\n}\n\n.logistik-hub-card .material-symbols-outlined {\n  color: var(--weiss);\n  font-size: 2.2rem;\n}\n\n.logistik-hub-card.secondary .material-symbols-outlined,\n.logistik-hub-card.secondary span:last-child {\n  color: var(--mittelblau);\n}\n\n.logistik-hub-card span:last-child {\n  color: var(--weiss);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.55rem;\n  line-height: 1;\n}\n\n.logistik-view-tabs,\n.logistik-day-chips,\n.logistik-person-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin: 0.75rem 0 1rem;\n}\n\n.logistik-view-tab,\n.logistik-day-chip,\n.logistik-person-chip {\n  width: auto;\n  min-height: auto;\n  margin: 0;\n  border: 2px solid var(--mittelblau);\n  border-radius: 999px;\n  background: var(--weiss);\n  color: var(--mittelblau);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  padding: 0.55rem 0.8rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.92rem;\n  line-height: 1;\n  text-align: center;\n}\n\n.logistik-view-tab.active,\n.logistik-day-chip.active,\n.logistik-person-chip:active {\n  background: var(--mittelblau);\n  color: var(--weiss);\n}\n\n.logistik-view-tab .material-symbols-outlined {\n  color: inherit;\n  font-size: 1.15rem;\n}\n\n.logistik-day-chip {\n  border-color: rgba(0, 80, 158, 0.38);\n  padding: 0.48rem 0.65rem;\n}\n\n.logistik-person-chips {\n  max-height: 14rem;\n  overflow: auto;\n  padding-bottom: 0.2rem;\n}\n\n.logistik-person-chips.compact {\n  max-height: none;\n}\n\n.logistik-search-panel {\n  margin: 0.75rem 0 1rem;\n}\n\n.logistik-search-panel label {\n  color: var(--mittelblau);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.15rem;\n  margin-bottom: 0.3rem;\n}\n\n.logistik-dienstplaene-page input.logistik-search-input {\n  width: 100%;\n  border: none;\n  border-radius: 8px;\n  background: rgba(180, 200, 130, 0.55);\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  padding: 0.85rem 0.95rem;\n  margin-bottom: 0;\n}\n\n.logistik-dienstplaene-page input.logistik-search-input::placeholder {\n  color: var(--placeholder);\n}\n\n.logistik-result-section,\n.logistik-subsection {\n  margin-top: 1.2rem;\n}\n\n.logistik-result-section h2,\n.logistik-subsection h3 {\n  color: var(--mittelblau);\n  text-align: left;\n}\n\n.logistik-subsection h3 {\n  font-size: 1.25rem;\n}\n\n.logistik-list {\n  display: grid;\n  gap: 0.55rem;\n}\n\n.logistik-duty-row,\n.logistik-ride-row,\n.logistik-ride-card {\n  border-radius: 8px;\n  background: var(--weiss);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);\n}\n\n.logistik-duty-row,\n.logistik-ride-row {\n  display: grid;\n  grid-template-columns: 5.6rem minmax(0, 1fr);\n  gap: 0.75rem;\n  align-items: start;\n  padding: 0.85rem 0.95rem;\n}\n\n.logistik-duty-time,\n.logistik-ride-time,\n.logistik-ride-date {\n  color: var(--mittelblau);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.logistik-duty-time {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.logistik-ride-time {\n  display: grid;\n  gap: 0.16rem;\n}\n\n.logistik-ride-time span,\n.logistik-ride-time small {\n  color: var(--mittelblau);\n}\n\n.logistik-ride-time small {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.82rem;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.logistik-repeat {\n  color: var(--mittelblau);\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.logistik-duty-title,\n.logistik-ride-title {\n  color: var(--dunkelgruen);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.25rem;\n  line-height: 1;\n}\n\n.logistik-duty-desc,\n.logistik-ride-meta,\n.logistik-ride-info,\n.logistik-person-list {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9rem;\n  line-height: 1.35;\n  margin-top: 0.18rem;\n}\n\n.logistik-person-list {\n  color: var(--dunkelgruen);\n  font-weight: 700;\n}\n\n.logistik-ride-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.logistik-ride-meta span {\n  display: inline-flex;\n  border-radius: 999px;\n  background: var(--blassgruen);\n  color: var(--mittelblau);\n  padding: 0.12rem 0.45rem;\n}\n\n.logistik-ride-card {\n  overflow: hidden;\n}\n\n.logistik-ride-card .logistik-ride-date {\n  background: var(--mittelblau);\n  color: var(--weiss);\n  padding: 0.45rem 0.95rem;\n}\n\n.logistik-ride-card .logistik-ride-row {\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.logistik-day-details {\n  border-radius: 8px;\n  background: var(--weiss);\n  margin-bottom: 0.65rem;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.logistik-day-details summary {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 0.95rem;\n  color: var(--mittelblau);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.25rem;\n  list-style: none;\n}\n\n.logistik-day-details summary::-webkit-details-marker {\n  display: none;\n}\n\n.logistik-day-details summary small {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.78rem;\n}\n\n.logistik-day-details .logistik-day-content {\n  padding: 0 0.75rem 0.85rem;\n}\n\n.logistik-inline-link {\n  display: inline-block;\n  margin-top: 0.65rem;\n  color: var(--mittelblau);\n  font-family: 'Circular', sans-serif;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.logistik-empty,\n.logistik-web-state {\n  border-radius: 8px;\n  background: var(--weiss);\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  padding: 1rem;\n  text-align: center;\n}\n\n.logistik-web-state.error {\n  color: var(--blutorange);\n}\n\n.logistik-service-note,\n.logistik-matrix-access {\n  border-radius: 8px;\n  background: var(--weiss);\n  color: var(--dunkelgruen);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);\n}\n\n.logistik-service-note {\n  padding: 0.85rem 0.95rem;\n  margin: 0 0 1rem;\n}\n\n.logistik-service-note span,\n.logistik-matrix-access summary {\n  display: block;\n  color: var(--mittelblau);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.15rem;\n}\n\n.logistik-service-note p {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9rem;\n  line-height: 1.35;\n  margin-top: 0.2rem;\n}\n\n.logistik-matrix-access {\n  padding: 0.7rem 0.85rem;\n  margin-top: 0.9rem;\n}\n\n.logistik-matrix-access summary {\n  cursor: pointer;\n  list-style: none;\n}\n\n.logistik-matrix-access summary::-webkit-details-marker {\n  display: none;\n}\n\n.logistik-matrix-access a {\n  display: inline-block;\n  margin-top: 0.65rem;\n  border: 2px solid var(--mittelblau);\n  border-radius: 999px;\n  color: var(--mittelblau);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9rem;\n  padding: 0.48rem 0.75rem;\n  text-align: center;\n}\n\n.logistik-matrix-wrapper {\n  width: 100%;\n  overflow: auto;\n  border-radius: 8px;\n  background: var(--hellgruen);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);\n}\n\n.logistik-matrix-table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: var(--hellgruen);\n}\n\n.logistik-matrix-table th,\n.logistik-matrix-table td {\n  min-width: 9rem;\n  border: none;\n  border-left: 1px solid rgba(100, 130, 2, 0.18);\n  border-top: 1px solid rgba(100, 130, 2, 0.18);\n  padding: 0.55rem;\n  vertical-align: top;\n  text-align: left;\n}\n\n.logistik-matrix-table thead th,\n.logistik-matrix-table tbody th {\n  background: var(--mittelblau);\n  color: var(--weiss);\n  font-family: 'Staatliches', sans-serif;\n}\n\n.logistik-matrix-table tbody th {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  min-width: 4.8rem;\n}\n\n.logistik-matrix-table td {\n  background: var(--blassgruen);\n  color: var(--dunkelgruen);\n}\n\n.logistik-matrix-table td.filled {\n  background: var(--weiss);\n}\n\n.logistik-matrix-entry {\n  display: grid;\n  gap: 0.12rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.85rem;\n  line-height: 1.25;\n}\n\n.logistik-matrix-entry strong {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-weight: 700;\n}\n\n.logistik-matrix-entry span {\n  color: var(--mittelblau);\n  font-family: 'Circular', sans-serif;\n}\n\n@media (max-width: 650px) {\n  .logistik-hub-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .logistik-view-tabs {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .logistik-view-tab {\n    width: 100%;\n  }\n\n  .logistik-duty-row,\n  .logistik-ride-row {\n    grid-template-columns: 1fr;\n    gap: 0.35rem;\n  }\n\n  .logistik-matrix-access a {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
